type TherapyTutorialsProps = {
	step: 'initial' | 'edit' | 'addSessions';
};

type RenderContentProps = {
	title: string;
	description: string;
};

enum TutorialStepsId {
	FORM_SESSIONS = 'refund-therapy-sessions-tutorial',
	FORM_ADD_SESSION = 'refund-therapy-add-session-tutorial',
	ADD_SESSIONS = 'refund-therapy-add-sessions-tutorial',
}

export {TutorialStepsId};
export type {TherapyTutorialsProps, RenderContentProps};
